
import { Link, useNavigate, useLocation } from "react-router-dom";


import React, { useState, useEffect, useRef } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import "./HamburgerMenu.css";
import DropDownmenu from "./DropDownmenu";

const HamburgerMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openState, setOpenState] = useState({
    lorem1: false,
    lorem2: false,
  });

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
    setActiveMenu(null);
  };
  const menuRef = useRef(null);

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleToggle = (menu) => {
    setActiveMenu(menu === activeMenu ? null : menu);
  };

  const [activeMenu, setActiveMenu] = useState(null);
  const closeMenu = () => {
    setActiveMenu(null);
  };

  const dropdownItems = [
    { text: "About Us", link: "/about-us" },
    { text: "Leadership", link: "/leadership" },
    { text: "Our Portfolio", link: "/our-portfolio" },
    { text: "Our Operations", link: "/our-operations" },
    { text: "Our Marquee Deployments", link: "/our-marquee-deployment" },
    { text: "Our Values", link: "/our-values" },
  ];

  const dropdownItems2 = [{ text: "Life At Crest", link: "/life-at-crest" }];
  const dropdownItems3 = [
    { text: "Announcements", link: "/announcement" },
    { text: "Codes and Policies", link: "/codes-policies" },
  ];
  const dropdownItems4 = [{ text: "Newsroom", link: "/newsroom" }];
  const dropdownItems5 = [
    { text: "Our Initiatives", link: "/our-initiatives" },
  ];
  const dropdownItems6 = [
    { text: "Careers", link: "/careers" },
    { text: "Contact Us", link: "/get-in-touch" },
  ];

  const navigate = useNavigate();

  const handleLinkClick = (link) => {
    navigate(link);
    window.location.reload();
  };
  const location = useLocation();

  const { pathname } = location;

  const isRouteActive = (targetRoute) => pathname === targetRoute;

  const handleLinkClick2 = (shouldCloseMenu) => {
    if (shouldCloseMenu) {
      setMenuOpen(false);
    }
  };
  
  return (
    <div ref={menuRef} className="hamburger-menu">
      <input
        id="menu__toggle"
        type="checkbox"
        checked={menuOpen}
        onChange={handleMenuToggle}
      />
      <label className="menu__btn" htmlFor="menu__toggle">
        <span></span>
      </label>
      <div className={`menu-overlay ${menuOpen ? "open" : ""}`}></div>
      <ul className="menu__box">
        <li
          className={`menu_item ${activeMenu === "1" ? "active" : ""}`}
          onClick={() => handleToggle("1")}
        >
          Who We Are
          <img src="/assets/expand.svg" alt="" className="expand" />
        </li>
        {activeMenu === "1" && (
          <DropDownmenu
            items={dropdownItems}
            closeMenu={() => setActiveMenu(null)}
          />
        )}

        <li
          className={`menu_item ${activeMenu === "2" ? "active" : ""}`}
          onClick={() => handleToggle("2")}
        >
          Our Culture
          <img src="/assets/expand.svg" alt="" className="expand" />
        </li>
        {activeMenu === "2" && (
          <DropDownmenu
            items={dropdownItems2}
            closeMenu={() => setActiveMenu(null)}
          />
        )}

        <li
          className={`menu_item ${activeMenu === "3" ? "active" : ""}`}
          onClick={() => handleToggle("3")}
        >
          Investor Relations
          <img src="/assets/expand.svg" alt="" className="expand" />
        </li>
        {activeMenu === "3" && (
          <DropDownmenu
            items={dropdownItems3}
            closeMenu={() => setActiveMenu(null)}
          />
        )}
        <li className="menu_item">
          <Link
          to='/our-partners'
          onClick={() => handleLinkClick2(true)}

            className={isRouteActive("/our-partners") ? "active1" : ""}
          >
            Our Partners
          </Link>
        </li>

        <li
          className={`menu_item ${activeMenu === "4" ? "active" : ""}`}
          onClick={() => handleToggle("4")}
        >
          Media
          <img src="/assets/expand.svg" alt="" className="expand" />
        </li>
        {activeMenu === "4" && (
          <DropDownmenu
            items={dropdownItems4}
            closeMenu={() => setActiveMenu(null)}
          />
        )}

        <li
          className={`menu_item ${activeMenu === "5" ? "active" : ""}`}
          onClick={() => handleToggle("5")}
        >
          CSR
          <img src="/assets/expand.svg" alt="" className="expand" />
        </li>
        {activeMenu === "5" && (
          <DropDownmenu
            items={dropdownItems5}
            closeMenu={() => setActiveMenu(null)}
          />
        )}

        <li className="menu_item">
          <Link
          to='/awards-and-recognitions'
            onClick={() => handleLinkClick2(true)}
            className={
              isRouteActive("/awards-and-recognitions") ? "active1" : ""
            }
          >
            Awards & Recognitions
          </Link>
        </li>
        <li
          className={`menu_item ${activeMenu === "6" ? "active" : ""}`}
          onClick={() => handleToggle("6")}
        >
          Get In Touch
          <img src="/assets/expand.svg" alt="" className="expand" />
        </li>
        {activeMenu === "6" && (
          <DropDownmenu
            items={dropdownItems6}
            closeMenu={() => setActiveMenu(null)}
          />
        )}
      </ul>
    </div>
  );
};

export default HamburgerMenu;
